import { gql } from "@apollo/client";

export const GET_USER_REPORT = gql`
query getAllUsersCsvReport {
    getAllUsersCsvReport {
        firstName
        lastName
        email
        active
        staff
        sysAdmin
        portalUser
        moduleRole
        portalUserSystems
        portalUserLhds
        portalUserInstitutions
    }
}
`
export const GET_LSL_REPORT = gql`
query GetLSLExportCsv {
  getLSLExportCsv {
    stream
    filename
  }
}
`